<div
  class="flex justify-between content-center"
  data-test-id="request-additional-availability-form-dialog"
>
  <h3
    mat-dialog-title
    class="text-blue"
    data-test-id="request-additional-availability-form-title"
  >
    Request additional availability
  </h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon data-test-id="request-additional-availability-form-close">
      clear
    </mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col">
      <h4 data-test-id="request-additional-availability-form-instruction-step">
        1. Review the project interview period
      </h4>
      <div class="flex flex-col gap-2">
        @if (interviewPeriodError()) {
          <app-alert
            type="error"
            heading="Failed to load the interview period"
            testId="request-additional-availability-form-interview-period-load-error-alert"
          >
            Please try again, or contact your delivery representative if this
            continues.
          </app-alert>
        }
        <p
          data-test-id="request-additional-availability-form-interview-period-note"
        >
          Times from the
          <a
            target="_blank"
            data-test-id="request-additional-availability-form-interview-period-note-link"
            [routerLink]="[
              '/connect',
              data.opportunity.publicDisplayId,
              'settings',
              'interview-period',
            ]"
            >project interview period</a
          >
          will be shared directly with the expert to guide their response to
          your request. The project interview period can be managed via the
          project settings.
        </p>
      </div>
      <app-request-additional-availability-interview-period-table
        [isLoading]="interviewPeriodLoading()"
        [availableSchedulePeriods]="availableSchedulePeriods()"
        [additionalAvailableSchedulePeriods]="
          additionalAvailableSchedulePeriods()
        "
        [callDuration]="data.expert.callDuration"
        [expertTimezone]="data.expert.timezoneName"
        (removeTime)="removeAvailableTime($event)"
      />
      @if (showInsufficientTimeAlert()) {
        <app-alert
          type="error"
          heading="Insufficient time"
          testId="request-additional-availability-form-insufficient-time-error-alert"
        >
          The times you have proposed are not sufficiently long for a call.
          Please ensure you have proposed times covering at least
          {{ data.expert.callDuration }} minutes.
        </app-alert>
      }
    </div>
    <div class="flex flex-col">
      <div
        class="flex justify-between content-center cursor-pointer"
        (click)="toggleShowAddTimes()"
      >
        <h4
          data-test-id="request-additional-availability-form-instruction-step"
        >
          2. Add more times (optional)
        </h4>
        <span>
          <mat-icon
            class="text-gray-300"
            data-test-id="request-additional-availability-form-toggle-add-times"
          >
            {{ showAddTimes() ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </span>
      </div>
      @if (showAddTimes()) {
        <div class="flex flex-col gap-2">
          @if (showAlert()) {
            <app-alert
              dismissible
              testId="request-additional-availability-form-expert-timezone-hint"
              [heading]="`${expertName} is in ${data.expert.timezoneName} (${offset()})`"
              (dismiss)="hideAlert()"
            >
              Please try to bear this in mind when suggesting times.
            </app-alert>
          }
          <p
            data-test-id="request-additional-availability-form-additional-times-message"
          >
            Any additional times you specify will be added to the project
            interview period going forward. We recommend using the project
            settings if you need to make major changes to the interview period.
          </p>
        </div>
        <app-schedule-add-available-times-form
          [allowWeekends]="true"
          [defaultTimezoneName]="timezoneName()"
          [disabled]="interviewPeriodLoading() || isSubmitting()"
          (addTimes)="addAvailableTimes($event)"
        />
      }
    </div>
    <div class="flex flex-col">
      <div
        class="flex justify-between content-center cursor-pointer"
        (click)="toggleShowAddComments()"
      >
        <h4
          data-test-id="request-additional-availability-form-instruction-step"
        >
          3. Add additional comments (optional)
        </h4>
        <span>
          <mat-icon
            class="text-gray-300"
            data-test-id="request-additional-availability-form-toggle-add-comments"
          >
            {{ showAddComments() ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </span>
      </div>
      @if (showAddComments()) {
        <mat-form-field appearance="outline">
          <mat-label
            data-test-id="request-additional-availability-form-additional-comments-label"
          >
            Additional comments
          </mat-label>
          <textarea
            matInput
            placeholder="Additional comments"
            class="free-text-area"
            data-test-id="request-additional-availability-form-additional-comments"
            [formControl]="comments"
          ></textarea>
        </mat-form-field>
      }
    </div>
    @if (showInterviewPeriodRefreshedAlert()) {
      <app-alert
        type="warning"
        testId="request-additional-availability-form-interview-period-refreshed-warning-alert"
      >
        The interview period was changed elsewhere and has been refreshed.
        Please review the changes and make any adjustments.
      </app-alert>
    }
    @if (submitError()) {
      <app-alert
        type="error"
        heading="Something went wrong"
        testId="request-additional-availability-form-submit-error-alert"
      >
        There was an error submitting your request. Please try again, or contact
        your delivery representative if this continues.
      </app-alert>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="button"
    mat-stroked-button
    mat-dialog-close
    color="primary"
    class="flex-1 primaryColor-border"
    data-test-id="request-additional-availability-form-cancel"
    [disabled]="interviewPeriodLoading()"
  >
    Cancel
  </button>
  <button
    class="flex-1"
    type="button"
    mat-flat-button
    color="primary"
    data-test-id="request-additional-availability-form-submit"
    [disabled]="interviewPeriodLoading() || isSubmitting()"
    (click)="submit()"
  >
    {{ isSubmitting() ? 'Sending...' : 'Send request' }}
  </button>
</mat-dialog-actions>
